import { Heart, MapPin, Send, UsersRound } from "lucide-react";
import { useEffect } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { api, json } from "../api";
import { useLocale } from "../App";
import { Distance, OnlineDot, PhoneShell } from "../components/Shell";

type WelcomeWoman = {
  id: string;
  name: string;
  age: number;
  online: boolean;
  city: string;
  distance_m: number;
  avatar_url: string | null;
};

export function WelcomeNearbyPage() {
  const lang = useLocale();
  const navigate = useNavigate();
  const query = useQuery({
    queryKey: ["welcome-nearby"],
    queryFn: () =>
      api<{ completed: boolean; women: WelcomeWoman[] }>(
        "/welcome/nearby?lang=vn",
      ),
  });
  useEffect(() => {
    if (query.data?.completed) navigate(`/${lang}/nearby`, { replace: true });
  }, [lang, navigate, query.data?.completed]);
  const greet = useMutation({
    mutationFn: () => api("/welcome/nearby/greet", json("POST", { lang })),
    onSuccess: () => navigate(`/${lang}/nearby`, { replace: true }),
  });
  const women = query.data?.women ?? [];
  return (
    <PhoneShell className="vn-welcome-page">
      <div className="vn-welcome-glow" />
      <header>
        <span className="vn-radar-pin"><MapPin/><i/><i/><i/></span>
        <h1>Gần bạn có {women.length || 6} cô gái</h1>
        <p>Bắt đầu kết nối ngay hôm nay</p>
      </header>
      {query.isLoading ? (
        <div className="vn-welcome-skeleton">{Array.from({length:6},(_,index)=><i key={index}/>)}</div>
      ) : (
        <section className="vn-women-grid">
          {women.map((woman) => (
            <article key={woman.id}>
              <img src={woman.avatar_url ?? "/dating-v1/seed/fallback.webp"} alt={woman.name}/>
              <div>
                <h2>{woman.name}, <b>{woman.age}</b>{woman.online?<OnlineDot/>:null}</h2>
                <p><MapPin/>{woman.city}<span>•</span><Distance meters={woman.distance_m}/></p>
              </div>
            </article>
          ))}
        </section>
      )}
      <footer>
        <p><Send/> Gửi lời chào đến {women.length || 6} người</p>
        <button type="button" disabled={women.length!==6||greet.isPending} onClick={()=>greet.mutate()}>
          <UsersRound/><span>Chào hỏi tất cả</span><Heart fill="currentColor"/>
        </button>
      </footer>
    </PhoneShell>
  );
}
